import saveUserHighlightService from '../services/saveUserHighlightService';
import userHighlightStore from '../store/userHighlightStore';
import removeUserMarkupPopupEventListener from '../utils/removeUserMarkupPopupEventListener';
import { logUsage } from 'owa-analytics';
import { ClientItem } from 'owa-mail-store';
import parseMarkId from 'owa-mark/lib/utils/parseMarkId';
import unmarkElements from 'owa-mark/lib/utils/unmarkElements';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('removeUserHighlight', (element: HTMLElement, item: ClientItem) => {
    // User highlights may be segmented into separate spans
    // This means the element may just contain part of a highlight
    // Obtain the original, full highlight from the userHighlightStore
    const highlightId = parseMarkId(element.className);
    const originalHighlight = userHighlightStore.highlightIds.get(highlightId);

    const itemUserHighlights: string[] = item.userHighlightData;
    const indexOfHighlight = itemUserHighlights && itemUserHighlights.indexOf(originalHighlight);
    const highlightFound = indexOfHighlight > -1;
    if (highlightFound) {
        itemUserHighlights.splice(indexOfHighlight, 1);

        // Remove user highlight from server
        saveUserHighlightService(item.ItemId.Id, itemUserHighlights);

        // Remove user highlight from DOM
        unmarkElements(highlightId, removeUserMarkupPopupEventListener);
    }

    // Log UserHighlightRemoved datapoint
    logUsage('UserMarkup_UserHighlightRemoved', [!highlightFound]);
});
